import React, { Component } from 'react';
import { getMultiLang } from '@platform/api';

class Wrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
            refName: props.refName,
            placeholder: props.placeholder,
            rootNode: props.rootNode,
            columnConfig: props.columnConfig,
            dropDownTitleConfig: props.dropDownTitleConfig,
            treeConfig: props.treeConfig,
            addButtons: props.addButtons,
        };
    }

    componentWillMount() {
        const { multiLang } = this.props;

        if (multiLang) {
            let { moduleId, currentLocale, domainName } = multiLang;
            this.getMultiLangJSON(moduleId, currentLocale, domainName, this.props);
        }
    }

	getMultiLangJSON = (moduleId, currentLocale, domainName, props) => {
	    getMultiLang({
	        moduleId,
	        currentLocale,
	        domainName,
	        callback: json => {
	            this.propsToState(props, json);
	        },
	    });
	};

	//WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
	componentWillReceiveProps(nextProps) {
	    const { multiLang: nextMultiLang, refcode: nextRefcode } = nextProps;
	    const { multiLang, refcode } = this.props;
	    if (nextMultiLang && multiLang) {
	        // eslint-disable-next-line one-var-declaration-per-line
	        let moduleId, currentLocale, domainName;
	        if (multiLang) {
	            ({ moduleId, currentLocale, domainName } = multiLang);
	        }
	        const {
	            moduleId: nextModuleId,
	            currentLocale: nextCurrentLocale,
	            domainName: nextDomainName,
	        } = nextMultiLang;
	        if (
	            moduleId !== nextModuleId ||
				currentLocale !== nextCurrentLocale ||
				domainName !== nextDomainName ||
				refcode !== nextRefcode
	        ) {
	            this.getMultiLangJSON(nextModuleId, nextCurrentLocale, nextDomainName, nextProps);
	        } else {
	            this.propsToState(nextProps, this.state.json);
	        }
	    } else {
	        this.setState({
	            refName: nextProps.refName,
	            placeholder: nextProps.placeholder,
	            rootNode: nextProps.rootNode,
	            columnConfig: nextProps.columnConfig,
	            dropDownTitleConfig: nextProps.dropDownTitleConfig,
	            treeConfig: nextProps.treeConfig,
	            addButtons: nextProps.addButtons,
	        });
	    }
	}

	propsToState = (props, json) => {
	    const {
	        refName: _refName,
	        placeholder: _placeholder,
	        rootNode: _rootNode,
	        columnConfig: _columnConfig,
	        dropDownTitleConfig: _dropDownTitleConfig,
	        treeConfig: _treeConfig,
	        addButtons: _addButtons,
	    } = props;
	    let { refName, placeholder, rootNode, columnConfig, dropDownTitleConfig, treeConfig, addButtons } = this.state;
	    // refName
	    refName = json[_refName] || _refName;
	    // placeholder
	    placeholder = json[_placeholder] || _placeholder;
	    // columnConfig
	    Array.isArray(_columnConfig) &&
			(columnConfig = _columnConfig.map(column => {
			    column.name = (column.name || []).map(name => json[name] || name);
			    return column;
			}));
	    // dropDownTitleConfig
	    Array.isArray(_dropDownTitleConfig) &&
			(dropDownTitleConfig = _dropDownTitleConfig.map(column => {
			    column.name = (column.name || []).map(name => json[name] || name);
			    return column;
			}));
	    // treeConfig
	    if (_treeConfig) {
	        _treeConfig.name = (_treeConfig.name || []).map(name => json[name] || name);
	        treeConfig = _treeConfig;
	    }
	    // rootNode
	    if (_rootNode) {
	        rootNode = rootNode || {};
	        Object.keys(_rootNode).forEach(e => {
	            rootNode[e] = json[_rootNode[e]] || _rootNode[e];
	        });
	    } else {
	        rootNode = null;
	    }
		
	    // addButtons
	    if (Array.isArray(_addButtons)) {
	        addButtons = _addButtons.map(button => {
	            button.name = json[button.name] || button.name;
	            return button;
	        })
	    }

	    this.setState({ json, refName, placeholder, rootNode, columnConfig, dropDownTitleConfig, treeConfig, addButtons });
	};

	render() {
	    let { refName, placeholder, rootNode, columnConfig, dropDownTitleConfig, treeConfig, addButtons, json } = this.state;
	    const { App, ...others } = this.props;
	    let extraProps = {};
	    refName && (extraProps.refName = refName);
	    placeholder && (extraProps.placeholder = placeholder);
	    rootNode && (extraProps.rootNode = rootNode);
	    columnConfig && (extraProps.columnConfig = columnConfig);
	    dropDownTitleConfig && (extraProps.dropDownTitleConfig = dropDownTitleConfig);
	    treeConfig && (extraProps.treeConfig = treeConfig);
	    addButtons && (extraProps.addButtons = addButtons);
	    return <App {...others} {...extraProps} multiLang={json} />;
	}
}
export default function MultiLangWrapper(App) {
    return function Container(params) {
        return <Wrapper App={App} {...params} />;
    };
}
